import React from "react";
const RicosDevToolsLazy = React.lazy(
  () => import(
    /* webpackChunkName: "ricos-dev-tools" */
    "./ricos-dev-tools.js"
  )
);
export {
  RicosDevToolsLazy
};
//# sourceMappingURL=ricos-dev-tools-lazy.js.map
